import { render, staticRenderFns } from "./companyPerformanceSetups.vue?vue&type=template&id=75bf4662"
import script from "./companyPerformanceSetups.vue?vue&type=script&lang=js"
export * from "./companyPerformanceSetups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports